import React, { PropTypes, Component } from 'react';
import { connect } from 'react-redux';
import { map, clone } from 'lodash';
import cx from 'classnames';

@connect()
export default class EmailList extends Component {

    static propTypes = {
        dispatch: PropTypes.func.isRequired,
        templates: PropTypes.array.isRequired,
        className: PropTypes.string,
        onSelectTemplate: PropTypes.func.isRequired,
    }

    constructor() {
        super();
        this.onSelectTemplate = ::this.onSelectTemplate;
        this.renderItem = ::this.renderItem;
    }

    onSelectTemplate(template) {
    
      this.props.onSelectTemplate && this.props.onSelectTemplate(template);
    }

    renderItem(template) {
        return (<div className={cx('email-item', { 'email-item-selected': template.selected, 'email-item-disabled': !template.enabled })} onClick={() => this.onSelectTemplate(template)}>
                {template.name}
                <div className='footer-note'>
                    {template.system ? 'System ' : 'User '}Template{template.jid != null ? `: ${template.jid}` : ''}
                </div>
            </div>);
    }
    
    render() {

        return (<div className={`email-list ${this.props.className}`}>
            <div>
                {map(this.props.templates, this.renderItem)}
            </div>
        </div>);
    }
}



// WEBPACK FOOTER //
// ./shared/react/admin/Settings/Emails/Landing/EmailList/index.js